import React from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { IconButton } from "@mui/material";
import { getTimeTrialStatus, formatStatus } from "../../utils";
import timeTrailsTransitioning from "../../assets/timetrails/time_trails_transitioning.svg";
import "./TimeTrailsTask.css";

// Utility function to format date
const formatDate = (dateString) => {
  if (!dateString) return "";

  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const inputDate = new Date(dateString);

  // Reset time to compare only dates
  const todayDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const yesterdayDate = new Date(
    yesterday.getFullYear(),
    yesterday.getMonth(),
    yesterday.getDate()
  );
  const inputDateOnly = new Date(
    inputDate.getFullYear(),
    inputDate.getMonth(),
    inputDate.getDate()
  );

  if (inputDateOnly.getTime() === todayDate.getTime()) {
    return "Today";
  } else if (inputDateOnly.getTime() === yesterdayDate.getTime()) {
    return "Yesterday";
  } else {

    // Format as locale date
    return inputDate.toLocaleDateString();
  }
};

// Utility function to determine date type for CSS classes
const getDateType = (dateString) => {
  if (!dateString) return "past";

  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const inputDate = new Date(dateString);

  // Reset time to compare only dates
  const todayDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const yesterdayDate = new Date(
    yesterday.getFullYear(),
    yesterday.getMonth(),
    yesterday.getDate()
  );
  const inputDateOnly = new Date(
    inputDate.getFullYear(),
    inputDate.getMonth(),
    inputDate.getDate()
  );

  if (inputDateOnly.getTime() === todayDate.getTime()) {
    return "today";
  } else if (inputDateOnly.getTime() === yesterdayDate.getTime()) {
    return "yesterday";
  } else {
    return "past";
  }
};

// Utility function to determine status type for CSS classes
const getStatusType = (status) => {
  switch (status?.toLowerCase()) {
    case "pending":
      return "pending";
    case "approved":
      return "approved";
    case "resend":
      return "resend";
    case "expired":
      return "expired";
    case "rejected":
      return "rejected";
    default:
      return "pending";
  }
};

export const TimeTrailsSidebar = ({
  timeTrials,
  selectedTaskId,
  sidebarOpen,
  onTaskSelect,
  onToggleSidebar,
}) => {
  return (
    <>
      {/* Left Sidebar */}
      <div
        className={`timetrails-task__sidebar ${
          !sidebarOpen ? "collapsed" : ""
        }`}
      >
        <div className="timetrails-task__sidebar-header">
          <img
            src={timeTrailsTransitioning}
            alt="Time Trials Icon"
            className="sidebar-icon"
          />
          <h2>Time Trials</h2>
        </div>

        <div className="timetrails-task__sidebar-list">
          {timeTrials?.data?.length === 0 ? (
            <div className="timetrails-task__sidebar-empty">
              <p>No time trials available</p>
            </div>
          ) : (
            timeTrials?.data?.map((trial) => {
              const formattedDate = formatDate(trial.startDate);
              const dateType = getDateType(trial?.startDate);

              // Use the new utility function to get status
              const displayStatus = getTimeTrialStatus(trial);
              const formattedStatus = formatStatus(displayStatus);
              const statusType = getStatusType(displayStatus);

              // Check if this trial is active (PENDING status)
              const isActiveTrial = displayStatus === "PENDING";

              return (
                <div
                  key={trial._id}
                  className={`timetrails-task__sidebar-item ${
                    selectedTaskId === trial._id ? "active" : ""
                  } ${isActiveTrial ? "active-trial" : ""}`}
                  onClick={() => onTaskSelect(trial._id)}
                >
                  <div className="timetrails-task__sidebar-date">
                    <span
                      className={`date-pill ${
                        selectedTaskId === trial._id ? "active" : ""
                      } ${dateType}`}
                    >
                      {formattedDate}
                    </span>
                  </div>
                  <div className="timetrails-task__sidebar-task">
                    {trial.task}
                  </div>
                  <div className="timetrails-task__sidebar-status">
                    <span className="status-text">Status : </span>
                    <span className={`status-text ${statusType}`}>
                      {formattedStatus}
                    </span>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* Sidebar Toggle Button */}
      <div
        className={`timetrails-task__sidebar-toggle ${
          !sidebarOpen ? "collapsed" : ""
        }`}
      >
        <IconButton
          onClick={onToggleSidebar}
          className="sidebar-toggle-btn"
          size="small"
        >
          {sidebarOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </div>
    </>
  );
};
